import { ClickEvent } from "@mcleod/components";
import { AutogenLayoutSmsMessages } from "./autogen/AutogenLayoutSmsMessages";
import { CarrierDriverMessage } from "@mcleod/powerbroker";
import { CarrierDriverMessageTaskFilterType } from "@mcleod/powerbroker";

export class SmsMessages extends AutogenLayoutSmsMessages {

  /** This is an event handler for the onClick event of labelUnread and labelUnreadCount.  */
  labelTotalOnClick(event: ClickEvent) {
    CarrierDriverMessage.navigateTo(CarrierDriverMessageTaskFilterType.ALL);
  }

  labelUnreadOnClick(event: ClickEvent) {
    CarrierDriverMessage.navigateTo(CarrierDriverMessageTaskFilterType.UNREAD);
  }

  /** This is an event handler for the onClick event of labelUndelivered and labelUndeliveredCount.  */
  labelPendingOnClick(event: ClickEvent) {
    CarrierDriverMessage.navigateTo(CarrierDriverMessageTaskFilterType.PENDING);
  }

  /** This is an event handler for the onClick event of labelFailed and labelFailedCount.  */
  labelFailedOnClick(event: ClickEvent) {
    CarrierDriverMessage.navigateTo(CarrierDriverMessageTaskFilterType.FAILED);
  }
}
